'use client'

import textBodyM from '@fukku/styles/texts/textBodyM.module.css'
import textPromoTitleS from '@fukku/styles/texts/textPromoTitleS.module.css'
import { SelectPromotion } from 'analytics/components/SelectPromotion/SelectPromotion'
import { ViewPromotion } from 'analytics/components/ViewPromotion/ViewPromotion'
import { cx } from 'classix'
import { conversion } from 'country-configuration/currency/conversion'
import { ClientLabel } from 'labels/components/ClientLabel/ClientLabel'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { promotionFactory } from '../../../analytics/promotionFactory'
import type { FamilyBanner } from '../../../Home.type'
import styles from './FamilyBanner.module.css'
import { FamilyBannerImage } from './FamilyBannerImage'

interface FamilyBannerComponentProps {
	readonly familyBanner: FamilyBanner
	readonly priority: boolean
	readonly slot: string
	readonly href: string
	readonly lowestPrice: number | undefined
	readonly imageSizes?: string
	readonly relativeWidth?: {
		small: number
		medium: number
		large: number
	}
}

export const FamilyBannerComponent = ({
	familyBanner,
	priority,
	slot,
	href,
	lowestPrice,
	imageSizes,
	relativeWidth,
}: FamilyBannerComponentProps) => {
	const { image, text: title, promotionName } = familyBanner

	const { country } = useMasterData()
	const { price: formattedLowestPrice, additionalPrices } = lowestPrice
		? conversion(lowestPrice, country)
		: {}
	const ctaToPromotion = promotionFactory(familyBanner, slot)
	const promotion = ctaToPromotion(promotionName)

	const { t } = useLabels()

	return (
		<ViewPromotion
			promotions={[promotion]}
			data-testid='landings.home.familyBanner'
		>
			<SelectPromotion promotion={promotion}>
				<a
					href={href}
					className={styles.familyBanner}
					draggable={false}
					data-testid='landings.home.familyBannerLink'
				>
					<FamilyBannerImage
						image={image}
						imageSizes={imageSizes}
						relativeWidth={relativeWidth}
						priority={priority}
					/>
					<div className={styles.textContainer}>
						<h2
							className={cx(
								styles.familyBannerTitle,
								textPromoTitleS.className
							)}
						>
							{title}
						</h2>
						{formattedLowestPrice && (
							<div className={textBodyM.className}>
								<ClientLabel placeholderValues={{ 1: formattedLowestPrice }}>
									{t('homeOutlet.cards.price.text')}
								</ClientLabel>
							</div>
						)}
						{additionalPrices?.map((additionalPrice) => (
							<div className={textBodyM.className} key={additionalPrice}>
								<ClientLabel placeholderValues={{ 1: additionalPrice }}>
									{t('homeOutlet.cards.price.text')}
								</ClientLabel>
							</div>
						))}
					</div>
				</a>
			</SelectPromotion>
		</ViewPromotion>
	)
}
